import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { IChoosenFilterInterface } from 'app/library/all-users/interfaces/choosen-filter.interface';
import { AllUsersApiService } from 'app/library/all-users/services/all-users.api-service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-certificate-date-filter',
    templateUrl: './certificate-date-filter.component.html',
    styleUrls: ['./certificate-date-filter.component.scss'],
})
export class CertificateDateFilterComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    type: 'IssueDate' | 'ExpirationDate';

    @Input()
    afterText: string;

    @Input()
    beforeText: string;

    @Output()
    addedToList = new EventEmitter<IChoosenFilterInterface[]>();

    dateFilterForm: FormGroup;
    list: IChoosenFilterInterface[] = [];
    isUpdating: boolean = false; // Flag to prevent infinite loop

    private _initValues(): void {
        const existingFilter = this.list.find((filter) => filter.entity.id === this.type);
        if (existingFilter) {
            const selected = {
                startDate: moment(existingFilter.rangeValue1),
                endDate: moment(existingFilter.rangeValue2),
            };

            this.isUpdating = true; // Prevent valueChanges from triggering emit
            this.dateFilterForm?.controls.after.setValue(selected.startDate, { emitEvent: false });
            this.dateFilterForm?.controls.before.setValue(selected.endDate, { emitEvent: false });
            this.isUpdating = false; // Allow future updates
        }
    }

    constructor(
        private _fb: FormBuilder,
        public dialogRef: MatDialogRef<CertificateDateFilterComponent>,
        private _translateService: TranslateService,
        private _allUsersService: AllUsersApiService
    ) {
        super();
    }

    ngOnInit(): void {
        this.dateFilterForm = this._fb.group({
            before: [null],
            after: [null],
        });

        this._allUsersService.filtersList$.pipe(takeUntil(this._unsubscribeAll)).subscribe((filters) => {
            this.list = filters;
            this._initValues();
        });

        ['after', 'before'].forEach((control) => {
            this.dateFilterForm.controls[control].valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
                if (this.isUpdating) return; // Prevent loop

                const afterValue = this.dateFilterForm.controls.after.value;
                const beforeValue = this.dateFilterForm.controls.before.value;
                if (beforeValue) {
                    this.addedToList.emit([
                        ...this.list.filter((value) => value.entity.id !== this.type),
                        {
                            entity: { id: this.type, type: this.type },
                            valueToShow: `${this._translateService.instant(
                                this.type === 'IssueDate' ? 'PAGE.CERTIFICATIONS.LABEL.ISSUE_DATE' : 'PAGE.CERTIFICATIONS.LABEL.EXPIRATION_DATE'
                            )}: ${moment(afterValue).format('YYYY/MM/DD')} - ${moment(beforeValue).format('YYYY/MM/DD')}`,
                            isRange: true,
                            rangeValue1: moment(afterValue).format(),
                            rangeValue2: moment(beforeValue).format(),
                        },
                    ]);
                }
            });
        });
    }
}
